<template>

  <main class="main-content" id="topDom">
    <section class="section">
      <ul class="breadcrumb">
        <li class="breadcrumb__li --current">
          <router-link to="/" class="breadcrumb__link">{{ $t("i18n.home") }}</router-link>
        </li>
        <li class="breadcrumb__li">
          <span class="breadcrumb__text"> {{ $t("i18n.CareerOpportunities") }}</span>
        </li>
      </ul>
      <div class="banner">
        <div class="banner__bg">
          <img :src="imgUrl" />
        </div>
        <div class="banner__content container-fluid">
          <div class="row align-items-center">
            <div class="col-12 col-md-6 order-2 order-md-1">
              <h1 class="banner__title">{{ $t("i18n.company") + $t("i18n.CareerOpportunities") }}</h1>
              <p class="banner__text" v-html="$t('i18n.CareerOpportunitiesText')"></p>
            </div>
          </div>
        </div>
      </div>

      <div class="properties container-fluid">
        <h1 style="font-size: 32px;">{{ $t('i18n.CareerOpportunitiesPageTitle') }}</h1>
        <div class="wp-block-columns">
          <div class="wp-block-column" v-for="(item, index) of $t('i18n.CareerOpportunitiesPageList')">
            <ul>
              <li>
                <h2>{{ item.title }}</h2>
                <span>{{ item.text }}</span>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </section>
    <section class="section footer">
      <div class="container-fluid">
        <div class="row">
          <div class="col-12 col-md-4">
            <router-link to="/recruitment" class="image-box">
              <div class="image-box__image">
                <img src="../assets/imgs/recruitmentSmallImg.png">
              </div>
              <div class="image-box__content">
                <h3 class="image-box__text">{{ $t('i18n.recruitment') }}</h3>
              </div>
            </router-link>
          </div>
          <div class="col-12 col-md-4 ml-auto">
            <div class="white-box__links">
              <a class="white-box__link" @click="goPage('/contactUs')">
                <strong class="white-box__link-label">
                  {{ $t("i18n.company") }}
                </strong>
                <h4 class="white-box__link-text">
                  {{ $t("i18n.contactUs") }}
                </h4>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  </main>
</template>

<script>
export default {
  name: "CareerOpportunities",
  data() {
    return {
      imgUrl: this.isMobile() ? require("../assets/imgs/CareerOpportunitiesBg-p.png") : require("../assets/imgs/CareerOpportunitiesImg.png"),
    }
  },
  // created() {
  //   this.goTop();
  // },
  mounted () {
    this.goTop()
  },
  methods: {
    isMobile() {
      return navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    },
    goPage(path) {
      this.$router.push(path)
    },
    goTop() {
      window.scrollTo({ top: 0, behavior: 'smooth' }); // 平滑滚动到顶部
      // document.querySelector('#topDom').scrollIntoView({
      //   behavior: 'smooth'
      // })
    }
  }
}
</script>

<style scoped>
.footer {
  margin-bottom: 10rem;
}
.breadcrumb {
  display: flex;
  height: 8rem;
  align-items: center;
  position: absolute;
  z-index: 80;
  left: 5rem;
  margin: 0;
  padding: 0;
}
.breadcrumb__li {
  position: relative;
  padding-right: 2.5rem;
  margin-right: 2rem;
}
.breadcrumb__link {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.breadcrumb__li.--current:after {
  content: "";
  width: 0.6rem;
  height: 1rem;
  position: absolute;
  right: 0;
  top: 50%;
  margin-top: -0.3rem;
  background: url(../assets/imgs/arrow-breadcrumb.svg) no-repeat 50%;
}
.breadcrumb__li:last-child {
  padding-right: 0;
  margin-right: 0;
}
.breadcrumb__text {
  font-size: 1.6rem;
  line-height: 1.9rem;
  color: #e3e3e3;
  letter-spacing: 0;
  display: block;
  max-width: 20rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.banner {
  height: 61rem;
  align-items: center;
  display: flex;
}
.banner__bg {
  position: absolute;
  width: 100%;
  height: 61rem;
}
.banner__bg {
  z-index: 1;
}
.banner__bg img {
  max-width: 100%;

  display: block;
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  -o-object-position: 50% 50%;
  object-position: 50% 50%;
}

.banner__content {
  position: relative;
  z-index: 2;
}
.banner__title {
  font-weight: 500;
  font-size: 4rem;
  color: #fff;
  letter-spacing: -.084rem;
  line-height: 6rem;
}
.banner__text {
  margin-top: 3rem;
  font-size: 2.1rem;
  font-weight: 500;
  color: #fff;
  letter-spacing: -.022rem;
  line-height: 3.3rem;
  padding-right: 2rem;
}

.properties {
  margin-top: 10rem;
  margin-bottom: 10rem;
  font-weight: normal;
  line-height: 3rem;
  font-size: 2.2rem;
}

.wp-block-columns {
  display: flex;
  margin-bottom: 28px;
  flex-wrap: wrap;
  margin-right: -12rem;
  margin-top: 4rem;
}
.wp-block-column{
  margin-right: 4rem
}
.wp-block-column ul li {
  position: relative;
  font-size: 2rem;
  color: #4c4c4c;
  letter-spacing: -.02rem;
  line-height: 3rem;
  margin-bottom: 1rem;
}
.wp-block-column ul li h2{
  font-size: 2.6rem;
}
.wp-block-column ul li span{
  position: relative;
  /* font-size: 2rem; */
  font-size: 1.6rem;
  letter-spacing: -.02rem;
  line-height: 3rem;
  margin-bottom: 1rem;
  font-weight: 200;
  color: #686868;
}

.white-box__links {
  cursor: pointer !important;
  position: relative;
  z-index: 2;
  background: #fff;
  border: 0.1rem solid #e6e6e6;
  display: flex;
  min-height: 18rem;
  width: 46rem;
  overflow: hidden;
  border-radius: 0.4rem;
  box-shadow: 0 0.2rem 0.4rem 0 rgba(0,0,0,.05);
  margin-bottom: 3rem;
}
.white-box__link:last-child {
  border: 0 !important;
}
.white-box__link {
  flex: 1;
  display: flex;
  justify-content: center;
  flex-direction: column;
  padding: 5rem;
  border-right: 0.1rem solid #e6e6e6;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-label, .white-box__link-label {
  font-weight: 500;
  /* font-size: 1.4rem; */
  font-size: 1.3rem;
  color: black;
  letter-spacing: .035rem;
  text-transform: uppercase;
  display: block;
  line-height: 1.7rem;
  margin-bottom: 1rem;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text, .white-box__link-text {
  font-weight: 500;
  font-size: 3rem;
  color: #990099;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  position: relative;
  padding-right: 1.5rem;
  margin: 0;
  transition: all .2s ease-in-out;
}
.g-content .white-box__link-text:after, .white-box__link-text:after {
  content: "";
  position: absolute;
  padding-right: 2rem;
  right: 0;
  width: 0.8rem;
  height: 1.4rem;
  top: 1.2rem;
  background: url(../assets/imgs/arrow-right.png) no-repeat 50%;
  transition: all .2s ease-in-out;
}

.image-box {
  display: flex;
  height: 40rem;
  width: 50rem;
  overflow: hidden;
  position: relative;
  padding: 5rem;
  border-radius: .4rem;
  transition: all .2s ease-in-out;
  z-index: 1;
}
.image-box__image {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  z-index: 1;
  overflow: hidden;
  border-radius: .4rem;
  -webkit-backface-visibility: hidden;
  -moz-backface-visibility: hidden;
  -webkit-transform: translateZ(0);
  -moz-transform: translateZ(0);
}
.image-box__image img {
  transition: all 0.3s;
  max-width: 100%;
}
.image-box__image:hover img {
  transform: scale(1.2); /* 鼠标悬停时放大1.1倍 */
}
.image-box__content {
  display: flex;
  width: 100%;
  margin-top: auto;
  position: relative;
  z-index: 3;
}
.image-box__text {
  font-weight: 500;
  font-size: 3rem;
  width: 100%;
  display: block;
  color: #fff;
  letter-spacing: -.015rem;
  line-height: 3.2rem;
  padding-right: 4rem;
  position: relative;
}

.image-box__text:after {
  content: "";
  position: absolute;
  right: 0;
  top: 0;
  width: .8rem;
  height: 1.4rem;
  margin-top: 1.2rem;
  background: #fff;
  -webkit-mask: url(../assets/imgs/arrow-right-big.svg) no-repeat center;
  mask: url(../assets/imgs/arrow-right-big.svg) no-repeat center;
  transition: all .2s ease-in-out;
}
</style>



// WEBPACK FOOTER //
// src/view/CareerOpportunities.vue